import { ENTITIES } from 'lib/constants';

export const ENTITIES_DATA = {
    [ENTITIES.ACCOUNTS.importExport]: {
        literal: 'cfm_label_accounts',
        addIcon: 'accountsAdd',
        editIcon: 'accountsEdit',
    },
    [ENTITIES.CONTACTS.importExport]: {
        literal: 'cfm_label_contacts',
        addIcon: 'contactAdd',
        editIcon: 'contactEdit',
    },
    [ENTITIES.OPPORTUNITIES.importExport]: {
        literal: 'cfm_label_opportunities',
        addIcon: 'opportunityAdd',
        editIcon: 'opportunityEdit',
    },
    [ENTITIES.USERS.importExport]: {
        literal: 'cfm_label_users',
        addIcon: 'contactAdd',
        editIcon: 'contactEdit',
    },
};

export const FILE_TYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
];

export const TYPES = {
    bit: 'bool',
    multivalue: 'multipleValueList',
    list: 'multipleValueList',
    currency: 'currency',
    decimal: 'decimal',
    percentage: 'percent',
    int: 'integer',
    datetime: 'date',
    text: 'text',
};

export const ADVANCED_IMPORT_IDENTIFIERS = {
    name: '0',
    id: '1',
    extId: '2',
};

export const MATCHING_VALUES = {
    noValue: -1,
    creatAsNew: -2,
};
